/**
 * Lookbook modal
 */
class LookbookModal extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('click', this.showLookbookModal.bind(this));
	}

	showLookbookModal() {
		const shopUrl = window.Shopify.routes.root;
		const lookbookItem = this.closest('lookbook-item');
		const modalId = this.getAttribute('data-lookbook-modal-id');
		const lookbookProductHandle = this.getAttribute('data-product-handle');
		const productHandleArray = lookbookProductHandle.split(',');
		const modalLookbook = document.getElementById('lookbook-modal-id-' + modalId);
		const imageHtml = lookbookItem.querySelector('.lookbook-image-content').innerHTML;

		let modalHtml = '';
		modalHtml += '<tpt-modal-component id="lookbook-modal-id-' + modalId + '" class="lookbook-modal fade" data-position="bottom" role="dialog" aria-modal="true" tabindex="0">';
		modalHtml += '<tpt-modal-dialog class="color-scheme-1 gradient">';
		modalHtml += '<tpt-modal-content>';

		modalHtml += '<tpt-modal-header>';
		modalHtml += '<div class="modal-title">';
		modalHtml += '&nbsp;';
		modalHtml += '</div>';

		modalHtml += '<button class="close-modal" data-close="modal" tabindex="0">';
		modalHtml += '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor"><path d="M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z"></path></svg>';
		modalHtml += '</button>';
		modalHtml += '</tpt-modal-header>';

		modalHtml += '<tpt-modal-body>';

		modalHtml += '<div class="page-width">';

		modalHtml += '<div class="modal-lookbook-container">';

		modalHtml += '<div class="modal-lookbook-image">' + imageHtml + '</div>';

		modalHtml += '<div class="modal-products scroll-bar">';
		modalHtml += '<div class="modal-body_data-ajax modal-body_loading tpt-grid desktop-3-columns tablet-3-columns mobile-2-columns">';
		modalHtml += '<div class="loader-component hidden"><span class="hidden">Loading...</span></div>';
		modalHtml += '</div>';
		modalHtml += '</div>';

		modalHtml += '</div>';

		modalHtml += '</div>';

		modalHtml += '</tpt-modal-body>';

		modalHtml += '</tpt-modal-content>';
		modalHtml += '</tpt-modal-dialog>';
		modalHtml += '</tpt-modal-component>';

		if (!modalLookbook) {
			document.body.insertAdjacentHTML('beforeend', modalHtml);

			productHandleArray.forEach((product) => {
				const fetchUrl = shopUrl + 'products/' + product + '?section_id=tpt-product-lookbook';

				fetch(fetchUrl)
					.then((response) => response.text())
					.then((responseText) => {
						const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
						const productElement = responseHTML.querySelector('#shopify-section-tpt-product-lookbook');

						document
							.getElementById('lookbook-modal-id-' + modalId)
							.querySelector('.modal-body_data-ajax')
							.insertAdjacentHTML('beforeend', productElement.innerHTML);
					})
					.finally(() => {
						const loadingElement = document.getElementById('lookbook-modal-id-' + modalId).querySelector('.loader-component');
						document
							.getElementById('lookbook-modal-id-' + modalId)
							.querySelector('.modal-body_data-ajax')
							.classList.remove('modal-body_loading');

						document.getElementById('lookbook-modal-id-' + modalId).focus();

						if (loadingElement) {
							loadingElement.remove();
						}
					});
			});
		}

		setTimeout(function () {
			document.getElementsByTagName('html')[0].classList.add('open-modal');
			document.getElementById('lookbook-modal-id-' + modalId).classList.add('show');
		}, 100);
	}
}

customElements.define('lookbook-modal-button', LookbookModal);
